<div class="ots-staff-header d-flex flex-direction-column gap-24 full-width position-relative p-t-40 p-x-40">
  <div class="ots-staff-header__top d-flex align-items-start justify-content-space-between gap-16 full-width">
    <div class="d-flex align-items-center gap-12">
      <div class="ots-staff-brand d-flex align-items-center justify-content-center c-bg-blue-100 medium-border-radius">
        <img
          src="/assets/images/ots/staff/dashboard.svg"
          alt=""
          width="32px"
          height="32px"
        />
      </div>
      <div class="d-flex flex-direction-column gap-8">
        <p class="p1 fw-semibold c-t-blue-900">
          {{ 'Staff Dashboard' | trans:'ots.staff.title' }}
        </p>
        <p class="p3 c-t-blue-900">{{ totalLabel() }}</p>
        @if (loadError()) {
          <p class="p3 c-t-blue-900">
            {{ 'Could not load kitchen orders.' | trans:'ots.staff.load_error' }}
          </p>
        }
      </div>
    </div>
    @if (showCloseButton) {
      <button
        type="button"
        class="ots-staff-close d-flex align-items-center justify-content-center c-t-blue-900 base-border-radius"
        [attr.aria-label]="'Close' | trans:'ots-staff/ots-staff-modal/close.Button'"
        (click)="closeRequested.emit()"
      >
        <i class="ri-close-line icon-md" aria-hidden="true"></i>
      </button>
    }
  </div>

  <div class="ots-staff-toolbar d-flex align-items-end gap-16 flex-wrap">
    <div class="ots-staff-toolbar__search d-flex align-items-end gap-8">
      <label class="ots-staff-search d-flex flex-direction-column">
        <span class="t1 c-t-blue-900 p-b-4">
          {{ 'Search' | trans:'ots.staff.search' }}
        </span>
        <span class="ots-staff-search__field d-flex align-items-center gap-8 full-width c-bg-gray-100 base-border-radius p-x-8">
          <img
            src="/assets/images/ots/staff/search.svg"
            alt=""
            width="20px"
            height="20px"
          />
          <input
            class="input full-width p2 c-t-blue-900"
            type="search"
            name="staffSearch"
            autocomplete="off"
            [value]="searchQuery()"
            [placeholder]="'Type here' | trans:'ots.staff.search_placeholder'"
            (input)="onSearchInput($event)"
          />
        </span>
      </label>
      <ots-staff-status-filter
        [options]="statusFilterOptions()"
        [filtersActive]="statusFiltersActive()"
        (statusToggled)="toggleStatus($event)"
      />
    </div>
    <button
      type="button"
      class="button button--primary c-t-gray-100 p-x-32 fw-medium white-space-nowrap"
    >
      {{ 'Search' | trans:'ots.staff.search_submit' }}
    </button>
  </div>
</div>

<div class="ots-staff-board d-flex gap-24 full-width overflow-hidden p-t-24 p-x-32 p-b-32">
  @if (statusFilters().new) {
    <ots-staff-order-column
      [title]="newTitle()"
      [cards]="newCards()"
      (advanceStatus)="moveToNextStatus($event)"
    />
  }

  @if (statusFilters().preparing) {
    <ots-staff-order-column
      [title]="preparingTitle()"
      [cards]="preparingCards()"
      (advanceStatus)="moveToNextStatus($event)"
    />
  }

  @if (statusFilters().ready) {
    <ots-staff-order-column
      [title]="readyTitle()"
      [cards]="readyCards()"
      (advanceStatus)="moveToNextStatus($event)"
    />
  }

  @if (statusFilters().done) {
    <ots-staff-order-column
      [title]="doneTitle()"
      [cards]="doneCards()"
      (advanceStatus)="moveToNextStatus($event)"
    />
  }
</div>
